const PULSE_COOKIE_NAME = '_pulse2data';

export { PULSE_COOKIE_NAME };
//# sourceMappingURL=constants.js.map
